<template>
    <Page :header="header[lang].title" :header_pos="'center'">
        <template #body>
            <div class="flex flex-column justify-content-center align-items-center">
                <span class="flex text-600 mb-4 mb-4 xl:mb-6 text-lg justify-content-center">
                    {{header[lang].subtitle}}
                </span>
                <div class="flex max-w-30rem w-full justify-content-center align-items-center">
                    <form @submit.prevent="handleSubmit(!v$.$invalid)" class="flex flex-column w-full p-fluid">

                        <!--NAME-->
                        <div class="field mt-2 mb-2">
                            <span class="text-color-secondary">{{ fields[lang].name }}:</span>
                            <div class="p-float-label">
                                <IconField >
                                    <InputText id="name" class='p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg'
                                        v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted}" />
                                    <InputIcon class="pi pi-user" />
                                </IconField>
                            </div>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>

                        <!--PASSWORD-->
                        <div class="field mt-2 mb-2">
                            <span class="text-color-secondary">{{ fields[lang].password.name }}:</span>
                            <div class="p-float-label">
                                <Password v-model="v$.password.$model" 
                                :class="{'p-invalid':v$.password.$invalid && submitted}"
                                class="p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg surface-border"
                                :promptLabel="fields[lang].password.promptLabel" :weakLabel="fields[lang].password.weakLabel" :mediumLabel="fields[lang].password.mediumLabel" :strongLabel="fields[lang].password.strongLabel"
                                toggleMask />
                            </div>
                            <small v-if="(v$.password.$invalid && submitted) || v$.password.$pending.$response" class="p-error">{{v$.password.required.$message.replace('Value', 'Password')}}</small>
                        </div>

                        <!--BTNS-->
                        <Button type="submit" :label="buttons[lang].save" class="mt-2 mb-3 p-button-lg w-full border-round-lg" :loading="isLoading"  />
                        <Button :label="buttons[lang].skip" @click="skip" text class="mt-2 p-button-lg w-full border-round-lg" severity="info"/>

                    </form>
                </div>
			</div>
        </template>
    </Page>
</template>


<script>
import Connect from '@/assets/js/Connect'
import Event from '@/assets/js/Event'
import { useVuelidate } from '@vuelidate/core'
import { required, maxLength, minLength } from '@vuelidate/validators'
import { mapActions } from "vuex"
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            header: {
                en: {
                    title: "Fill your data",
                    subtitle: "This will help us to know you better",
                } ,
                ru: {
                    title: "Заполните ваши данные",
                    subtitle: "Это поможет нам лучше вас узнать",
                } ,
            },
            fields:  {
                en:{
                    name: "Fill your name",
                    login : "Create a login",
                    password: {
                        name:"Password",
                        pick_password:"Pick a password",
                        enter_password:"Enter a password", 
                        suggestions:"Suggestions",
                        one_lowercase:"At least one lowercase",
                        one_uppercase:"At least one uppercase",
                        one_numeric:"At least one numeric", 
                        characters: "Minimum 8 characters",
                        promptLabel: "Choose a password",
                        weakLabel: "Too simple",
                        mediumLabel: "Average complexity",
                        strongLabel: "Complex password",
                    },
                },
                ru:{
                    name: "Введите имя",
                    login : "Придумайте логин",
                    password:{
                        name:"Пароль",
                        pick_password:"Выберите пароль",
                        enter_password:"Введите пароль", 
                        suggestions:"Предложения",
                        one_lowercase:"Хотя бы одна строчная буква",
                        one_uppercase:"Хотя бы одна Заглавная буква",
                        one_numeric:"Хотя бы одна Цифра", 
                        characters: "Минимум 8 символов", 
                        promptLabel: "Введите пароль",
                        weakLabel: "Слишком простой",
                        mediumLabel: "Уже лучше",
                        strongLabel: "Идеально!",
                    },                    
                }                 
            },
            buttons:  {
                en:{
                    save : "Save",
                    skip: "Skip",
                },
                ru:{
                    save : "Сохранить",
                    skip: "Пропустить",
                }                 
            },
            messeges: {
                en: {
                    success_title: "Success",
                    success_subtitle: "Profile filled successfully",
                    error: "filling error",
                },
                ru: {
                    success_title: "Успех",
                    success_subtitle: "Профиль успешно заполнен",
                    error: "Ошибка заполнения",
                },
            },
            name: null,
            hash: null,
            password: '',
            error: false,
            submitted: false,
            showMessage: false,
            isLoading: false,
            v$: useVuelidate(),
            visible: false,
        }
    },
    validations() {
        return {
            name: {
                required,
                minimunLength: minLength(3),
                maxLength: maxLength(20),
            },
            password: {
                required,
                minimunLength: minLength(5),
                maxLength: maxLength(30),
            }
        }
    },
    components: {
        Page
    },
    methods: {
        skip() {
            this.event.send('regFillSkip')
            this.$router.push({path: '/reg/email/'})
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        ...mapActions(["ActionRegFill"]),
        async handleSubmit(isFormValid) {
            this.submitted = true
            this.isLoading = true

            if (!isFormValid) {
                this.isLoading = false
                return;
            }

            try {
                const fill = await this.ActionRegFill({name: this.name, password: this.password}).then(res=>res)
                if(fill.result && fill.data) {
                    this.showMess('success', this.messeges[this.lang].success_title, this.messeges[this.lang].success_subtitle,)
                    this.event.send('regFillSent')
                    this.$router.push({path: '/reg/email/'})
                    this.isLoading = false
                    this.submitted = false
                } else {
                    this.isLoading = false
                    this.submitted = false
                    if(fill.errors) {
                        for (let i = 0; i < fill.errors.length; i++) {
                            this.showMess('error', this.messeges[this.lang].error, fill.errors[i])
                        }
                    } else {
                        this.showMess('error', this.messeges[this.lang].error, 'filling error')
                    }
                }
            } catch (error) {
                this.showMess('error', 'Error', 'filling error')
                this.isLoading = false
                this.submitted = false
            } 
        },
    },
    computed: {
        lang() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        }
    },
    async beforeCreate () {
        this.connect = new Connect()
        this.event = new Event(this)
    },
    mounted(){
        // берем хэш из урла
        if(this.$route.query.hash) {
            this.hash = this.$route.query.hash
        }
        try{
            this.event.send('regSuccess')
        } catch (e) {
            console.error('Event not found:', e)
        }
    },
}
</script>